import { createConfigContext } from '@pegasus/config';
import { Config } from 'src/config/types';

const { ConfigProvider, useConfig, injectConfig, withConfig } = createConfigContext<Config>({
    appdomainId: 17,
    appdomain: 'de',
} as Config);

export { ConfigProvider, useConfig, injectConfig, withConfig };
